import script from "./Player.vue?vue&type=script&setup=true&lang=js"
export * from "./Player.vue?vue&type=script&setup=true&lang=js"

import "./Player.vue?vue&type=style&index=0&id=5419742e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5419742e"]])

export default __exports__